import timeRange from './timeRange'
import dataExplorer from './queries'

export default {
  timeRange,
  dataExplorer,
}
